import { render, staticRenderFns } from "./TournamentCreate.vue?vue&type=template&id=76b1696e&scoped=true&"
import script from "./TournamentCreate.vue?vue&type=script&lang=js&"
export * from "./TournamentCreate.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1696e",
  null
  
)

export default component.exports